import styled from '@emotion/styled';
import React from 'react';

const SkeletonBlock = styled.div`
  border-radius: 8px;
`;

const TeamCardSkeleton = styled(SkeletonBlock)`
  height: 84px;
`;

const formStyles = {
  height: '120px',
  width: '100%',
};

const ChampionshipTeamsSkeleton = () => {
  const teams = new Array(3).fill('');

  return (
    <>
      <div className="mb-10 flex items-center">
        <SkeletonBlock className="skeleton-block w-full" style={{ height: '78px' }} />
      </div>

      <SkeletonBlock className="skeleton-block mb-12" style={formStyles} />

      <div>
        {teams.map((team, index) => (
          <TeamCardSkeleton key={index} className="skeleton-block mb-4 last:mb-0" />
        ))}
      </div>
    </>
  );
};

export default ChampionshipTeamsSkeleton;
